import { Action, createAction } from 'redux-act';

import FacebookPage from '../../../../models/interfaces/FacebookPage';
import TimestampPayload from '../../TimestampPayload';

export interface SaveFacebookPagePayload extends TimestampPayload {
  placeUuid: string;
  facebookPage: FacebookPage;
}
export const saveFacebookPage = createAction<SaveFacebookPagePayload>('SAVE_FACEBOOK_PAGE');
export type SaveFacebookPageActionType = Action<SaveFacebookPagePayload>;

export interface FacebookPageSaveResponsePayload extends TimestampPayload {
  placeUuid: string;
  facebookPage: FacebookPage;
}
export const facebookPageSaved = createAction<FacebookPageSaveResponsePayload>('FACEBOOK_PAGE_SAVED');

export const facebookPageSaveFailed = createAction<FacebookPageSaveResponsePayload>('FACEBOOK_PAGE_SAVE_FAILED');
